import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface PortfolioQueryParams {
  startDate?: string;
  endDate?: string;
}

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private apiUrl = environment.baseUrl + 'user/';

  private sessionTokenSubject = new BehaviorSubject<string | null>(null);
  sessionToken$ = this.sessionTokenSubject.asObservable();
  private sessionRefreshTokenSubject = new BehaviorSubject<string | null>(null);
  sessionRefreshToken$ = this.sessionRefreshTokenSubject.asObservable();
  private sessionNameSubject = new BehaviorSubject<string | null>(null);
  sessionName$ = this.sessionNameSubject.asObservable();

  constructor(private http: HttpClient) {}

  setSessionToken(token: string | null) {
    this.sessionTokenSubject.next(token);
  }

  getSessionToken(): Observable<string | null> {
    return this.sessionToken$;
  }

  setSessionRefreshToken(token: string | null) {
    this.sessionRefreshTokenSubject.next(token);
  }

  getSessionRefreshToken(): Observable<string | null> {
    return this.sessionRefreshToken$;
  }

  setSessionName(name: string | null) {
    this.sessionNameSubject.next(name);
  }

  getSessionName(): Observable<string | null> {
    return this.sessionName$;
  }

  getWallets() {
    return this.http.get(this.apiUrl + 'wallets');
  }

  getAccounts() {
    return this.http.get(this.apiUrl + 'list-accounts');
  }

  getPortfolio(query?: PortfolioQueryParams) {
    let params = new HttpParams().set('granularity', 'day');
    if (query?.startDate) {
      params = params.set('startDate', query.startDate);
    }
    if (query?.endDate) {
      params = params.set('endDate', query.endDate);
    }
    return this.http.get(this.apiUrl + 'portfolio', { params });
  }

  createAccount(numberAccount: string, codeCurrency: string) {
    const params = {
      numberAccount,
      codeCurrency,
      entity: 'BCP',
    };
    return this.http.post(this.apiUrl + 'create-accounts', params);
  }

  deleteAccount(accountId: number) {
    return this.http.delete(this.apiUrl + 'delete-accounts/' + accountId);
  }

  editNickname(alias: string) {
    return this.http.put(this.apiUrl + 'alias', {
      alias: alias.trim().toLowerCase(),
    });
  }

  getAlias() {
    return this.http.get(this.apiUrl + 'alias');
  }

  validateAccount(numberAccount: string, codeCurrency: string) {
    return this.http.post(this.apiUrl + 'validate-accounts', {
      numberAccount,
      codeCurrency,
      entity: 'BCP',
    });
  }

  updateAccount(accountId: number, numberAccount: string, codeCurrency: string) {
    return this.http.put(this.apiUrl + 'update-accounts/' + accountId, {
      numberAccount,
      codeCurrency,
      entity: 'BCP',
    });
  }

  unsubscribeUser() {
    return this.http.delete(this.apiUrl + 'deactivate', {});
  }
}
